/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Load_Preset_ButtonInputs */

const en_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load Preset`)
};

const fr_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger le prereglage`)
};

const de_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung laden`)
};

const it_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica preimpostato`)
};

const ru_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить предустановку`)
};

const es_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar ajuste preestablecido`)
};

const zh_cn2_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载预设`)
};

const ja_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットをロード`)
};

const hi_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट लोड करें`)
};

const pt_pt2_transcript_export_load_preset_button = /** @type {(inputs: Transcript_Export_Load_Preset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar predefinição`)
};

/**
* | output |
* | --- |
* | "Load Preset" |
*
* @param {Transcript_Export_Load_Preset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_load_preset_button = /** @type {((inputs?: Transcript_Export_Load_Preset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Load_Preset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_load_preset_button(inputs)
	if (locale === "de") return de_transcript_export_load_preset_button(inputs)
	if (locale === "it") return it_transcript_export_load_preset_button(inputs)
	if (locale === "ru") return ru_transcript_export_load_preset_button(inputs)
	if (locale === "es") return es_transcript_export_load_preset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_load_preset_button(inputs)
	if (locale === "ja") return ja_transcript_export_load_preset_button(inputs)
	if (locale === "hi") return hi_transcript_export_load_preset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_load_preset_button(inputs)
	return en_transcript_export_load_preset_button(inputs)
});